<div class="container">
  <h1>{{ 'case.title' | translate | capitalize }}</h1>
  @if (data) {
    <div class="card-primary">
      <app-list
        [title]="title"
        [columns]="columns"
        [data]="data"
        [pageSizeOptions]="[10, 25, 50]"
        [addButton]="addBtn"
        [searchBar]="true"
        (rowClick)="onRowClick($event)"
        (columnActionClick)="onColumnActionClick($event)"
        (addClick)="onAddClick()"></app-list>
    </div>
  }
  @if (!data) {
    <app-skeleton-list> </app-skeleton-list>
  }
</div>
